export enum SignUpStepsEnum {
  FIRST = 'first',
  FORM = 'form',
  INTEREST = 'interest',
}